// Note: This context will become more sophisticated

import React from 'react'

// =======================================================
// Create Context
// =======================================================

const PageContext = React.createContext()

// =======================================================
// Export
// =======================================================

export {
   PageContext as default
}
